import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector, TemplateRef, Type, inject } from '@angular/core';
import { MyOverlayRef } from '../ui/overlay/myoverlay-ref';
import { OverlayComponent } from '../ui/overlay/overlay.component';

export interface DialogConfig {
  hasBackdrop?: boolean;
  closeOnBackdropClick?: boolean;
  width?: string;
  maxWidth?: string;
  panelClass?: string[];
  backdropClass?: string;
}

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private overlay = inject(Overlay);
  private injector = inject(Injector);

  open<R = any, T = any>(
    content: TemplateRef<any> | Type<any> | string,
    data?: T,
    config?: DialogConfig,
  ): MyOverlayRef<R> {
    const overlayConfig = this.buildConfig(config);
    const overlayRef = this.overlay.create(overlayConfig);
    const dialogRef = new MyOverlayRef<R, T>(
      overlayRef,
      content as any,
      data as T,
      config?.closeOnBackdropClick ?? true,
    );

    const injector = Injector.create({
      parent: this.injector,
      providers: [{ provide: MyOverlayRef, useValue: dialogRef }],
    });

    overlayRef.attach(new ComponentPortal(OverlayComponent, null, injector));

    return dialogRef;
  }

  private buildConfig(config?: DialogConfig): OverlayConfig {
    return new OverlayConfig({
      hasBackdrop: config?.hasBackdrop ?? true,
      backdropClass: config?.backdropClass ?? 'dialog-overlay-backdrop',
      panelClass: config?.panelClass ?? ['dialog-overlay-panel'],
      width: config?.width,
      maxWidth: config?.maxWidth,
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
    });
  }
}
